export const baseFont = { family: `'Inter', sans-serif` };
